.Portrait {
  position: relative;
}
.Portrait .PortraitLayer {
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: none;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: auto 100%;
  mask-position: center bottom;
  mask-repeat: no-repeat;
  mask-size: auto 100%;
}
